import { render, staticRenderFns } from "./TutorAdd.vue?vue&type=template&id=0776aff4&scoped=true"
import script from "./TutorAdd.vue?vue&type=script&lang=ts"
export * from "./TutorAdd.vue?vue&type=script&lang=ts"
import style0 from "./TutorAdd.vue?vue&type=style&index=0&id=0776aff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0776aff4",
  null
  
)

export default component.exports